import { useTranslation } from "react-i18next"
import { publicAssetUrl } from "@/lib/publicAssetUrl"

/** Высота ряда логотипов партнёров в хедере */
export const navbarPartnerRowMinHeight = "min-h-[30px] sm:min-h-[34px]"
/** Кнопки-иконки в хедере (войти, выход, уведомления) — тот же габарит, что у ряда партнёров */
export const navbarHeaderIconButtonSize = "h-[30px] w-[30px] sm:h-[34px] sm:w-[34px]"
export const navbarHeaderIconSize = "text-lg"

export type NavbarPartnersProps = {
  /** Узкий хедер (главная): компактные логотипы, без наезда на кнопки справа */
  compact?: boolean
}

export const NavbarPartners = ({ compact = false }: NavbarPartnersProps) => {
  const { t } = useTranslation()

  return (
    <div
      className={`flex min-w-0 ${navbarPartnerRowMinHeight} items-center shrink-0 ${
        compact ? "sm:flex-1 sm:min-w-0" : ""
      }`}
      role="group"
      aria-label={t("nav.ailaEcosystemAria")}
    >
      <img
        src={publicAssetUrl("images/partners/aila.png")}
        alt={t("nav.partnerAilaAlt")}
        className={
          compact
            ? "h-3.5 w-auto max-w-[2rem] sm:h-4 sm:max-w-[2.5rem] md:h-5 md:max-w-[3rem] object-contain object-center transition-opacity duration-300"
            : "h-4 w-auto max-w-[2.75rem] sm:h-5 sm:max-w-[3.5rem] md:h-6 md:max-w-[4.25rem] lg:h-7 lg:max-w-[5rem] object-contain object-center transition-opacity duration-300"
        }
        width={80}
        height={28}
        decoding="async"
      />
    </div>
  )
}
